import React, { useState, useEffect } from "react";
import Header from "../components/Layout/Header";
import CoreFaculty from "../components/Submenu/CoreFaculty/CoreFaculty";
import Footer from "../components/Layout/Footer";
// import Cursor from "../common/Cursor";
import Loading from "../common/Loading";
import { CorefacultysActions } from "../Store/Core Faculty/action";
import { useDispatch, useSelector } from 'react-redux'
import gsap from 'gsap';
import { PageOpeningAnimation } from "../common/pageOpeningAnimation";

function Corefaculty() {
  document.title = "Core Faculty  | PSG-IAP";
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch({ type: CorefacultysActions.GET_COREFACULTY_SECTION });
  }, [dispatch]);

  const { CoreFacultyDetails } = useSelector(
    (state) => state?.CorefacultysReducer
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    if (CoreFacultyDetails?.length !== 0) {
      setLoading(false)
    } else {
      setLoading(false)
    }
  }, [CoreFacultyDetails])

  //for page opening animations
  useEffect(() => {
    if (!loading) {
      const svg = document.getElementById("svg");
      const tl = gsap.timeline({ repeat: 0, yoyo: true });

      tl.to('.bluee', {
        duration: 1,
        attr: { d: 'M0 502S175 272 500 272s500 230 500 230V0H0Z' },
        ease: 'power2.in',
      }).to('.bluee', {
        duration: 1,
        attr: { d: 'M0 2S175 1 500 1s500 1 500 1V0H0Z' },
        ease: 'power2.out',
      });

      // Start SVG animation after the loading text is hidden
      tl.add(() => {
        gsap.to(svg, {
          duration: 0.8,
          attr: { d: 'M0 502S175 272 500 272s500 230 500 230V0H0Z' },
          ease: 'power2.in',
        });
      });

      // Clean up animation on unmount
      return () => {
        tl.kill(); // Kill the animation to prevent memory leaks
      };
    }
  }, [loading]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* <Cursor /> */}
          <PageOpeningAnimation />
          <Header />
          <CoreFaculty />
          <Footer />
        </>
      )}
    </div>
  );
}

export default Corefaculty;
